<template>
  <div class="pinwall__search">
    <label class="label">{{ $t("search") }}</label>
    <SearchInput
      :value="search"
      @input="searchInput"
      :placeholder="$t('searchContent.placeholder')"
    ></SearchInput>
    <b-tabs
      position="is-centered is-info"
      class="block"
      v-model="selectedTab"
      @change="tabChanged"
    >
      <b-tab-item label="PINWALL" icon="post"></b-tab-item>
      <b-tab-item label="YOUTUBE" icon="youtube"></b-tab-item>
      <b-tab-item label="IMAGES" icon="google-photos"></b-tab-item>
      <b-tab-item label="GIPHY" icon="image"></b-tab-item>
      <b-tab-item
        v-if="
          tenantId === 'srg' || tenantId === 'srf' || tenantId === 'swisstxt'
        "
        label="INTERACTIVE VIDEO"
        icon="video"
      ></b-tab-item>

      <Search-List
        @add="add"
        @select="select"
        :items="searchResult.items"
      ></Search-List>
      <b-button
        v-if="selectedTab != 3"
        class="more-button action-button"
        type="is-success"
        @click="getSearchResult($event, true)"
        rounded
        >{{ $t("more") }}</b-button
      >
    </b-tabs>
  </div>
</template>
<script>
import {
  youtubeSearch,
  googleImageSearch,
  giphySearch,
  interactiveVideoSearch
} from "../../services/search";
import SearchList from "./SearchList";
import SearchInput from "../core/SearchInput";
import { mapActions } from "vuex";

export default {
  name: "search",
  components: {
    SearchList,
    SearchInput
  },
  props: {
    search: {
      default: String
    },
    tenantId: {
      default: String
    }
  },
  data: () => {
    return {
      searchResult: {
        items: []
      },
      showItems: 0,
      selectedTab: 0
    };
  },
  methods: {
    ...mapActions(["getSearchPosts"]),
    add(item) {
      item.action = "add";
      this.$emit("add", item);
    },
    select(item) {
      item.action = "select";
      this.$emit("select", item);
    },
    tabChanged(value) {
      this.selectedTab = value;
      this.getSearchResult({
        key: "Enter"
      });
    },
    searchInput(value) {
      this.searchValue = value;
      this.getSearchResult({ key: "Enter" });
    },
    getSearchResult(e, more) {
      if (e.key === "Enter" || event.type === "click") {
        if (this.selectedTab === 0) {
          this.showItems = more ? this.showItems + 12 : 12;
          this.getSearchPosts({
            searchValue: this.searchValue,
            tenantId: this.tenantId,
            sort: "new",
            view: "list",
            initialLoad: false,
            showItems: this.showItems
          }).then(result => {
            this.searchResult.items = [];

            if (!result.posts) {
              return;
            }

            result.posts.map(post => {
              var item = {
                title: unescape(post.text),
                image: post.image ? { source: post.image.source } : null,
                playMedia: false,
                proportion: post.proportion,
                video: post.video,
                approved: true,
                post: post
              };

              this.searchResult.items.push(item);
            });
          });
        }

        if (this.selectedTab === 1) {
          youtubeSearch(
            this.searchValue,
            more ? this.searchResult.nextPageToken : null
          ).then(result => {
            if (more) {
              result.items.map(item => {
                this.searchResult.items.push(item);
              });
              this.searchResult.nextPageToken = result.nextPageToken;
            } else {
              this.searchResult = result;
            }
          });
        }

        if (this.selectedTab === 2) {
          googleImageSearch(this.searchValue, this.searchResult.start).then(
            result => {
              if (more) {
                result.items.map(item => {
                  this.searchResult.items.push(item);
                });
              } else {
                this.searchResult = result;
              }
            }
          );
        }
        if (this.selectedTab === 3) {
          giphySearch(this.searchValue, this.searchResult.offset).then(
            result => {
              if (more) {
                result.items.map(item => {
                  this.searchResult.items.push(item);
                });
              } else {
                this.searchResult = result;
              }
            }
          );
        }

        if (this.selectedTab === 4) {
          interactiveVideoSearch(this.searchValue).then(result => {
            if (more) {
              result.items.map(item => {
                this.searchResult.items.push(item);
              });
            } else {
              this.searchResult = result;
            }
          });
        }
      }
    }
  },
  created() {
    this.searchValue = this.search;
    this.getSearchResult({
      key: "Enter"
    });
  }
};
</script>
